// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_found = /** @type {(inputs: {}) => string} */ () => {
	return `found`
};

const el_found = /** @type {(inputs: {}) => string} */ () => {
	return `βρ​έθηκαν`
};

const ru_found = /** @type {(inputs: {}) => string} */ () => {
	return `найдено`
};

const he_found = /** @type {(inputs: {}) => string} */ () => {
	return `נמצאו`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const found = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.found(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("found", locale)
	if (locale === "en") return en_found(inputs)
	if (locale === "el") return el_found(inputs)
	if (locale === "ru") return ru_found(inputs)
	if (locale === "he") return he_found(inputs)
	return "found"
};